export const isExternalUrl = (url) => /^https?:\/\//.test(url);
